import { userService } from "@/utils/services";
import { compress, decompress } from 'lz-string';
import axios from 'axios';

const handleErrorResponse = {
  'status': 401,
  'title': 'Internal Error',
  'detail': 'Internal error, check response log.',
};

export const postRequestHandler = async (url, data, headers = {}) => {
  return await axios.post(url, data, headers)
    .then(response => {
      if (response.data.status === 401) {
        userService.logout();
      }

      if (url.includes('/availability')) {
        return {
          'availabilities': response,
          'status': response.status,
          'title': 'mostrando disponibilidad',
          'detail': 'encontramos ' + response.data.data.length + ' opciones de disponibilidad',
          'availabilityQuantity': response.data.data.length
        };
      }

      if (url.includes('/bookings')) {
        if (url.includes('/bookings/update')) {
          return response.data;
        }
        if (url.includes('/bookings/cancel')) {
          return response.data;
        }
        return {
          'bookings': response.data.data.bookings,
          'pagination': response.data.data.pagination,
          'status': response.data.status
        };
      }

      if (url.endsWith('/hotels/inventory')) {
        return {
          'roomtype': response.data.data,
          'data': response.data,
          'status': response.data.status
        };
      }

      if (url.includes('/rateplans/rates/check')) {
        return {
          'data':response.data.data,
          'status':response.data.status
        }
      }

      if (url.includes('/rateplans/create') ||
        url.includes('/rateplans/update') ||
        url.includes('/rates/create') ||
        url.includes('/hotels/inventory/create') ||
        url.includes('/rates/update')) {
        return {
          'data': response.data,
          'status': response.data.status
        };
      }

      if (url.includes('/hotels/create') ||
        url.includes('/hotels/update') ||
        url.includes('/hotels/images/delete') ||
        url.includes('/hotels/images/create')) {

        return response;
      }

      if (url.includes('/rateplans')) {
        return {
          'rateplans': response.data.data.rateplans,
          'pagination': response.data.data.pagination,
          'status': response.data.status
        };
      }

      if (url.includes('/rates')) {
        return {
          'data': response.data,
          'pagination': response.data.data.pagination,
        };
      }

      if (url.endsWith('/hotels/roomtypes')) {
        return {
          'roomtypes': response.data.data,
          'status': response.data.status
        };
      }

      return response.data;
    })
    .catch(error => {
      return handleErrorResponse;
    });

};

export const getRequestHandler = async (url, headers = {}) => {
  return await axios.get(url, headers)
    .then(response => {
      if (response.data.status === 401) {
        userService.logout();
      }

      if (url.includes('/hotels/user')) {
        return response;
      }

      if (url.includes('/hotels/categories') ||
        url.endsWith('/hotels')) {

        return response.data.data;
      }

      if (url.includes('/town')) {
        localStorage.setItem(`cities`, compress(JSON.stringify(response.data.data)));
        return response.data.data;
      }

      if (url.includes('/ammenities')) {
        localStorage.setItem(`ammenities`, compress(JSON.stringify(response.data.data)));
        return response.data.data;
      }

      if (url.endsWith('/clients')) {
        return response.data;
      }

      if (url.includes('/currencies')) {
        localStorage.setItem(`global:currencies`, compress(JSON.stringify(response.data.data)));
      }

      if (url.includes('/countries')) {
        localStorage.setItem(`countries`, compress(JSON.stringify(response.data.data)));
        return response.data.data;
      }

      return response.data.data;

    }).catch(error => {
      return handleErrorResponse;
    });
};

// THIS HAS BEEN CLEANED DUE TO SERVICES DEPRECATION, BASE CODE FOR DELETE REQUESTS
// IS KEPT FOR FUTURE USAGE
export const deleteRequestHandler = async (url, headers={})=>{
    await axios.delete(url, headers).then( response => {



    return response;
  }).catch(error => {
    return handleErrorResponse;
  });


};

export const paginationRequestHandler = async (navigationHttpMethod, navigationParams = {}, headers = {}) => {
  return await axios[navigationHttpMethod](...navigationParams, headers)
    .then(response => {
      return {
        'bookings': response.data.data,
        'status': response.data.status
      };
    }).catch(error => {
      return handleErrorResponse;
    });
};



// WEBPACK FOOTER //
// ./src/utils/services/handlers/request.handler.js